export const SearchReceiveablesPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">미수채권 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">상태</label>
                            <select className="form-select w-150px">
                                <option>30일이하</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">매출일자</label>
                            <div className="frm_field">
                                <div className="frm_field input_date">
                                    <input type="date" className="form-control" />
                                    <span className="txt_range">~</span>
                                    <input type="date" className="form-control" />
                                    <button className="btn btn-info btn_search">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">세금계산서 목록(<span>23</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기</button>
                    </div>
                </div>

                <table className="table table-bordered my_table">
                    <thead>
                        <tr>
                            <th style={{ width: "4.4%" }}>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </th>
                            <th>매출일자</th>
                            <th>수금예정</th>
                            <th>담당자</th>
                            <th>고객사</th>
                            <th>경과일수</th>
                            <th>매출액</th>
                            <th>수금액</th>
                            <th>미수잔액</th>
                            <th>출하번호</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">2024-09-30</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">㈜구구구</td>
                            <td className="text-center">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-end">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-center">ABCDE1234</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">2024-09-30</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">㈜구구구</td>
                            <td className="text-center">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-end">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-center">ABCDE1234</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">2024-09-30</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">㈜구구구</td>
                            <td className="text-center">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-end">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-center">ABCDE1234</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">2024-09-30</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">㈜구구구</td>
                            <td className="text-center">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-end">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-center">ABCDE1234</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">2024-09-30</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">㈜구구구</td>
                            <td className="text-center">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-end">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-center">ABCDE1234</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">2024-09-30</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">㈜구구구</td>
                            <td className="text-center">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-end">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-center">ABCDE1234</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">2024-09-30</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">㈜구구구</td>
                            <td className="text-center">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-end">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-center">ABCDE1234</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">2024-09-30</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">㈜구구구</td>
                            <td className="text-center">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-end">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-center">ABCDE1234</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">2024-09-30</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">㈜구구구</td>
                            <td className="text-center">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-end">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-center">ABCDE1234</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">2024-09-30</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">㈜구구구</td>
                            <td className="text-center">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-end">0</td>
                            <td className="text-end">100,000</td>
                            <td className="text-center">ABCDE1234</td>
                        </tr>
                    </tbody>
                </table>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}